import React from 'react';
import Button from '@mui/material/Button';
import { Table, Input, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import {SearchRounded, RestartAltRounded, ManageSearchRounded, SortRounded} from "@mui/icons-material";

const TableSearch = ({ columns, data, ...props }) => {
  const [searchText, setSearchText] = React.useState('');
  const [searchedColumn, setSearchedColumn] = React.useState('');
  const [visibleFilter, setVisibleFilter] = React.useState(false);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
    setSearchedColumn('');
    setVisibleFilter(false);

  };
  const handleVisibleChange = visible => {
    setVisibleFilter(visible);
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            startIcon={<SearchRounded />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
              startIcon={<RestartAltRounded/>}
              onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => <ManageSearchRounded sx={{color: '#ccc'}}/>,
    onFilter: (value, record) =>
      searchText && dataIndex === searchedColumn
        ? record[dataIndex].toString().toLowerCase().includes(searchText.toLowerCase())
        : true,
    onCell: () => ({
      onClick: () => setVisibleFilter(true)
    })
  });

  const searchableColumns = columns.map((col) => ({
    ...col,
    ...(col.searchable ? getColumnSearchProps(col.dataIndex) : {}),
  }));

  return <Table columns={searchableColumns} dataSource={data} {...props} />;
};

export default TableSearch;
